import { TServerErrorResponse, SuggestedParticipants } from "@/types";
import { http } from "../httpHandler";
import { links } from "@/constants";

export const PRE_MEETING_SUGGESTED_PARTICIPANTS_GET =
  "pre-meeting-suggested-participants-get";

// Meeting mode when a calendar event is selected; local-day window mode
// otherwise. The server has no default window — both bounds are required.
export type PreMeetingSuggestedParticipantsParams =
  | { meetingId: string }
  | { startAt: number; endAt: number };

export const getPreMeetingSuggestedParticipants = async (
  params: PreMeetingSuggestedParticipantsParams,
): Promise<SuggestedParticipants> => {
  try {
    const response = await http.get<SuggestedParticipants>(
      links.suggestedParticipant.index,
      { params },
    );
    return response.data ?? [];
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};
